import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { EmployeeSService } from 'src/app/services/modelService/employeeS.service';
import { NotificationTriggerService } from 'src/app/services/notification-trigger.service';
import { WhatsappService } from 'src/app/services/whatsapp.service';
import { LoaderService } from 'src/app/util/loader.service';
import { ToastService } from 'src/app/util/toast.service';

@Component({
  selector: 'app-approvers',
  templateUrl: './approvers.component.html',
  styleUrls: ['./approvers.component.scss'],
})

export class ApproversComponent implements OnInit {
  empList = [];
  isApproverModalOpen = true;
  @Input() whatsappMessage: string;
  @Input() heading: string;
  @Input() description: string;
  @Output() closePopup = new EventEmitter<string>();
  constructor(private empService: EmployeeSService, private auth: AuthService, private whatsapp: WhatsappService,
    private notify: NotificationTriggerService, private toast: ToastService, private loader: LoaderService
  ) { }

  ngOnInit() {
    this.empService.findAreaManger(this.auth.loggedInEmployee.user.user_pd).then((empList: any) => {
      this.empList = empList;
      for (let emp of this.empList) {
        console.log(emp);
      }
    });
  }
  async clickApprover(emp) {
    this.loader.show();
    console.log(emp);
    await this.notify.sendNotificationToAreaManagers(this.heading, this.whatsappMessage, this.auth.loggedInEmployee.user.url, '/user-list');
    await this.whatsapp.sendMessage(emp.user.mobile, this.whatsappMessage);
    this.closePopup.emit();
    this.toast.success("Notification sent to approver " + emp.user.name);
    this.loader.hideForce();
  }
}
